import { SubAPI } from "./SubAPI";
export class ConfigureSourcing extends SubAPI {
    upsert(input) { return this.fetcher.post("/api/logistics/configure-sourcing", input); }
    get(input) { return this.fetcher.get("/api/logistics/configure-sourcing", input); }
    list(input) { return this.fetcher.get("/api/logistics/configure-sourcing/list", input); }
    addItems(input) { return this.fetcher.post("/api/logistics/configure-sourcing/group/add-items", input); }
    removeItems(input) { return this.fetcher.post("/api/logistics/configure-sourcing/group/remove-items", input); }
    listGroups(input) { return this.fetcher.get("/api/logistics/configure-sourcing/groups", input); }
    upsertGroups(input) { return this.fetcher.post("/api/logistics/configure-sourcing/group", input); }
    listSourceItems(input) { return this.fetcher.get("/api/logistics/configure-sourcing/src-items", input); }
    upsertSourceItem(input) { return this.fetcher.post("/api/logistics/configure-sourcing/src-item", input); }
    listChildren(input) { return this.fetcher.get("/api/logistics/configure-sourcing/children", input); }
    previewItem(input) { return this.fetcher.get("/api/logistics/configure-sourcing/preview-item", input); }
    build(input) { return this.fetcher.post("/api/logistics/configure-sourcing/build", input); }
    listOutput(input) { return this.fetcher.get("/api/logistics/configure-sourcing/previews", input); }
}
